import { LoaderCircle } from 'lucide-react'

export function LoadingNotice({ message }: { message: string }) {
  return (
    <p data-slot="loading-notice" role="status" className="text-muted-foreground flex items-center gap-2 p-6 text-sm">
      <LoaderCircle aria-hidden="true" className="size-4 shrink-0 animate-spin" />
      {message}
    </p>
  )
}
